import { render, staticRenderFns } from "./deliver.vue?vue&type=template&id=cf79b16a&scoped=true"
import script from "./deliver.vue?vue&type=script&lang=js"
export * from "./deliver.vue?vue&type=script&lang=js"
import style0 from "./deliver.vue?vue&type=style&index=0&id=cf79b16a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf79b16a",
  null
  
)

export default component.exports